import { render, staticRenderFns } from "./DisciplinePortfolioRegister.vue?vue&type=template&id=3e753730"
import script from "./DisciplinePortfolioRegister.vue?vue&type=script&lang=js"
export * from "./DisciplinePortfolioRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports